/***
 * 地域分布分析
 */
import { post, get, postJson, put } from '../axios'

//导出数据
export const exportDataOne = p => postJson(`/customer-analysis/geography-analysis/export`, p);

// 列表数据
export const getTableData = p => get(`/customer-analysis/geography-analysis/list`, p);